{
  "name": "visua11y-agent",
  "type": "module",
  "version": "1.15.0",
  "description": "Zero-dependency universal accessibility (a11y) website widget and toolbar for WCAG 2.1 & ADA compliance, high contrast, dyslexia fonts, screen reader, and voice navigation.",
  "keywords": [
    "accessibility",
    "a11y",
    "accessibility-widget",
    "accessibility-toolbar",
    "wcag",
    "wcag21",
    "ada-compliance",
    "screen-reader",
    "voice-navigation",
    "dyslexia-font",
    "high-contrast",
    "web-accessibility",
    "a11y-agent",
    "reading-guide",
    "zero-dependency",
    "userway-alternative",
    "aksesibilitas",
    "aksesibilitas-web",
    "widget-aksesibilitas",
    "disabilitas",
    "ramah-disabilitas",
    "pembaca-layar",
    "kontras-tinggi",
    "buta-warna",
    "disleksia",
    "bahasa-indonesia"
  ],
  "main": "dist/visua11y-agent.cjs.js",
  "module": "dist/visua11y-agent.esm.js",
  "unpkg": "dist/visua11y-agent.umd.js",
  "jsdelivr": "dist/visua11y-agent.umd.js",
  "files": [
    "dist",
    "types",
    "README.md",
    "LICENSE"
  ],
  "types": "./types/index.d.ts",
  "exports": {
    ".": {
      "types": "./types/index.d.ts",
      "import": "./dist/visua11y-agent.esm.js",
      "require": "./dist/visua11y-agent.cjs.js"
    },
    "./core": {
      "types": "./types/index.d.ts",
      "import": "./dist/visua11y-agent.esm.js",
      "require": "./dist/visua11y-agent.cjs.js"
    },
    "./slim": {
      "types": "./types/index.d.ts",
      "import": "./dist/visua11y-agent.slim.esm.js",
      "require": "./dist/visua11y-agent.slim.cjs.js"
    },
    "./package.json": "./package.json"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "sideEffects": false,
  "scripts": {
    "dev": "vite",
    "build": "vite build && vite build --mode umd && vite build --mode slim && node scripts/copy-locales.js",
    "preview": "vite preview",
    "lint": "eslint src --ext .ts,.js",
    "test": "vitest run --pool=threads",
    "test:watch": "vitest",
    "test:ui": "vitest --ui",
    "release": "npx semantic-release",
    "docs:dev": "vitepress dev docs",
    "docs:build": "vitepress build docs",
    "docs:build-demo": "node scripts/build-demo.js",
    "docs:publish": "npm run build && npm run docs:build-demo && npm run docs:build"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/chulit/visua11y-agent.git"
  },
  "author": "Chulit",
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/chulit/visua11y-agent/issues"
  },
  "homepage": "https://chulit.github.io/visua11y-agent/",
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@semantic-release/commit-analyzer": "^13.0.1",
    "@semantic-release/exec": "^7.1.0",
    "@semantic-release/git": "^11.0.1",
    "@semantic-release/github": "^12.0.9",
    "@semantic-release/npm": "^13.1.5",
    "@semantic-release/release-notes-generator": "^14.1.1",
    "@vitest/ui": "^4.1.11",
    "esbuild": "^0.25.0",
    "eslint": "^10.8.1",
    "jsdom": "^30.0.1",
    "prettier": "^3.9.6",
    "search-insights": "^2.17.3",
    "semantic-release": "^25.0.9",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.67.0",
    "vite": "^8.2.1",
    "vitepress": "^1.6.4",
    "vitest": "^4.1.11"
  },
  "overrides": {
    "esbuild": "^0.25.0",
    "vitepress": {
      "vite": "^6.4.3"
    }
  }
}
